angular.module('edxResources')
  .component('edxWistiaResource', {
    bindings: {
      wistiaId: '<',
      analyticsCategory: '<',
      moduleName: '<',
      name: '<',
      htmlName: '<?',
      description: '<?',
      isNew: '<'
    },
    templateUrl: '/resources/components/edx-resources/edx-wistia-resource.component.html',
    controllerAs: 'vm',
    controller: function() {}
  });
